export default Object.freeze({
  New: 1,
  Approved: 2,
  Closed: 3,
  Submitted: 4,
});
